import axios from 'axios'

export default {
    namespaced: true,
    state: {
        bursaryApplicationChecklistStatuses: [],
    },
    mutations: {
        SET_BURSARY_APPLICATION_CHECKLIST_STATUSES(state, payload) {
            state.bursaryApplicationChecklistStatuses = payload;
        },
    },
    actions: {
        async FetchBursaryApplicationChecklistStatuses({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/bursary/checklist/statuses/list`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_BURSARY_APPLICATION_CHECKLIST_STATUSES', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchBursaryApplicationChecklistStatuses: ${error.message}`));
            });
        },
    },
    getters: {
        BursaryApplicationChecklistStatuses(state) { return state.bursaryApplicationChecklistStatuses; },
    }
}
